import React, { Component } from 'react';
import { Modal, Upload } from 'antd';
import config from '../../config';
import { CloudUploadOutlined } from '@ant-design/icons';
import { getFileProps } from 'utils';
import './MediaUploadDialog.scss';
const baseUrl = config.baseUrl;

export default class MediaUploadDialog extends Component {
	getSignedURLEndpoint = (clientID, libraryID, eventID) => {
		let signedUrlEndpoint;
		if (eventID) {
			signedUrlEndpoint = libraryID
				? `${baseUrl}/${clientID}/events/${eventID}/upload/libraries/${libraryID}/signed_url`
				: `${baseUrl}/${clientID}/events/${eventID}/upload/media/signed_url`;
		} else {
			signedUrlEndpoint = libraryID
				? `${baseUrl}/${clientID}/upload/libraries/${libraryID}/signed_url`
				: `${baseUrl}/${clientID}/upload/media/signed_url`;
		}
		return signedUrlEndpoint;
	};

	render() {
		const {
			open,
			client = {},
			library = {},
			event = {},
			onCancel,
			handleCreateMedia,
			stack,
			multiple,
			mediaType,
		} = this.props;
		const signedUrlEndpoint = this.getSignedURLEndpoint(client.id, library.id, event.id);
		const imgCallback = (aliasedSignedUrl, file) =>
			handleCreateMedia(aliasedSignedUrl, file, library.id, event.id);

		const imgProps = getFileProps({
			signedUrlEndpoint,
			isMedia: true,
			multiple,
			mediaType,
			callback: imgCallback,
		});

		return stack ? (
			<Upload.Dragger {...imgProps}>
				<CloudUploadOutlined />
				<p>Click or drag files to this area to upload</p>
			</Upload.Dragger>
		) : (
			<Modal
				title="Upload Media"
				open={open}
				onCancel={onCancel}
				footer={null}
				destroyOnClose={true}
				className={'MediaUploadDialog'}
			>
				<Upload.Dragger {...imgProps}>
					<CloudUploadOutlined />
					<p>Click or drag files to this area to upload</p>
				</Upload.Dragger>
			</Modal>
		);
	}
}
